import { Tooltip as VcdkTooltip } from '@volvo/vcdk-react';
import React, { useState } from 'react';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type TooltipPlacement = 'left' | 'right' | 'top' | 'bottom' | 'top-start' | 'bottom-start';

type Props = {
  element: React.ReactNode;
  content: string;
  width?: number;
  placement?: TooltipPlacement;
};

const Tooltip: React.FC<Props> = ({ content, element, width = 300, placement = 'top' }) => {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);

  return (
    <React.Fragment>
      <div ref={(ref) => setReferenceElement(ref)}>{element}</div>
      <VcdkTooltip reference={referenceElement} placement={placement} offset={10}>
        <span className="block text-balance whitespace-normal" style={{ maxWidth: width }}>
          {content}
        </span>
      </VcdkTooltip>
    </React.Fragment>
  );
};

export default withComponentErrorBoundary(Tooltip);
